import React from 'react';

const sizes = {
  small: ['12px', '12px'],
  middle: ['16px', '16px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const EmptyListIcon = (props) => {
  const width = sizes[props.size][0];
  const height = sizes[props.size][1];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fillRule="evenodd"
      clipRule="evenodd"
      width={width}
      height={height}
      style={{
        ...(props.shouldPadding
          ? {
              padding: '4px',
            }
          : {}),
      }}
    >
      <path
        fill="#172b4d"
        d="M34.575 28.064H38.574000000000005V45.067H34.575z"
        transform="rotate(-45.001 36.574 36.567)"
      />
      <path
        fill="#616161"
        d="M19.969 3.9800000000000004A16 16 0 1 0 19.969 35.980000000000004A16 16 0 1 0 19.969 3.9800000000000004Z"
      />
      <path
        fill="#36474f"
        d="M36.188 32.106H40.187000000000005V44.405H36.188z"
        transform="rotate(-45.001 38.187 38.257)"
      />
      <path
        fill="#5fb3f9"
        d="M19.969 6.98A13 13 0 1 0 19.969 32.980000000000004A13 13 0 1 0 19.969 6.98Z"
      />
      <path
        fill="#f5f5f5"
        d="M26.764,25.286C25.1,23.232,22.651,22,20.007,22s-5.092,1.232-6.757,3.286 c-0.394,0.413-0.295,1.132,0.096,1.44c0.394,0.41,1.078,0.305,1.373-0.104c1.369-1.646,3.208-2.61,5.267-2.61 c2.059,0,3.938,0.964,5.308,2.61c0.199,0.204,0.799,0.61,1.374,0.204C27.13,26.502,27.059,25.7,26.764,25.286z"
      />
      <path
        fill="#f5f5f5"
        fillRule="evenodd"
        d="M14.5 15A1.5 1.5 0 1 0 14.5 18 1.5 1.5 0 1 0 14.5 15zM25.5 15A1.5 1.5 0 1 0 25.5 18 1.5 1.5 0 1 0 25.5 15z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default EmptyListIcon;
